import {
  getAutomationMasterTemplate,
  getAutomationMasterList,
  getAutomationMasterById,
  createAutomationMaster,
  updateAutomationMaster,
  deleteAutomationMaster,
  getAutomationStep,
  createAutomationStep,
  updateAutomationStep,
  deleteAutomationStep,
} from "@/http/setup/automationMaster.js";

export default {
  namespaced: true,
  state: {
    automationTemplate: {},
    automationList: [],
    automationMasterById: {},
    automationStepList: [],
  },
  actions: {
    async getAutomationMasterTemplateAction({ commit }) {
      try {
        const resp = await getAutomationMasterTemplate();
        commit("SET_AUTOMATION_TEMPLATE", resp.data);
        return resp;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async getAutomationMasterListAction({ commit }) {
      try {
        const resp = await getAutomationMasterList();
        commit("SET_AUTOMATION_LIST", resp.data);
        return resp;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async getAutomationMasterByIdAction({ commit }, id) {
      try {
        const resp = await getAutomationMasterById(id);
        commit("SET_AUTOMATION_MASTER_BY_ID", resp.data[0]);
        return resp;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async createAutomationMasterAction(_, data) {
      try {
        const resp = await createAutomationMaster(data);
        return resp;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async updateAutomationMasterAction(_, data) {
      try {
        const resp = await updateAutomationMaster(data.id, data.data);
        return resp;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async deleteAutomationMasterAction(_, id) {
      try {
        const resp = await deleteAutomationMaster(id);
        return resp;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async getAutomationStepAction({ commit }, id) {
      try {
        const resp = await getAutomationStep(id);
        commit("SET_AUTOMATION_STEP_LIST", resp.data);
        return resp;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async createAutomationStepAction(_, data) {
      try {
        const resp = await createAutomationStep(data);
        return resp;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async updateAutomationStepAction(_, data) {
      try {
        const resp = await updateAutomationStep(data.id, data.data);
        return resp;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async deleteAutomationStepAction(_, id) {
      try {
        const resp = await deleteAutomationStep(id);
        return resp;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
  },
  mutations: {
    SET_AUTOMATION_TEMPLATE(state, payload) {
      state.automationTemplate = payload;
    },
    SET_AUTOMATION_LIST(state, payload) {
      state.automationList = payload;
    },
    SET_AUTOMATION_MASTER_BY_ID(state, payload) {
      state.automationMasterById = payload;
    },
    SET_AUTOMATION_STEP_LIST(state, payload) {
      state.automationStepList = payload;
    },
  },
};
